import React from 'react';

const Ads = ({ className }) => {

  return (
    <div className={className}>
    </div>
  );
}

export default Ads;